import { render, staticRenderFns } from "./ReasonForCancel.vue?vue&type=template&id=48890e5f&"
import script from "./ReasonForCancel.vue?vue&type=script&lang=js&"
export * from "./ReasonForCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports